import { render } from "./ModalSkeleton.vue?vue&type=template&id=3be84e0e&scoped=true"
import script from "./ModalSkeleton.vue?vue&type=script&lang=js"
export * from "./ModalSkeleton.vue?vue&type=script&lang=js"

import "./ModalSkeleton.vue?vue&type=style&index=0&id=3be84e0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be84e0e"]])

export default __exports__